(() => {
	angular.module('main').directive('addMail', addMail);

	addMail.$inject = [
		'templateRequestsService',
		'messageService',
		'fileUploadService',
		'emailService'
	];

	function addMail(
		templateRequestsService,
		messageService,
		fileUploadService,
		emailService
	) {
		return {
			restrict: 'E',
			scope: {
				email: '=',
				emailInfo: '<',
				emailTemplates: '<'
			},
			template: ` <div>
                            <div class="field-info">
                                <h4>Choose email template</h4>

                                <div class="flex-row flex-just-space flex-wrap-md">
                                    <div class="flex-basis-full">
                                        <div class="select-style">
                                            <select ng-model="email"
                                                    ng-change="getEmailTemplate(email)"
                                                    ng-disabled = "!emailTemplates.length || emailTemplates.length === 1"
                                                    ng-options="template as template.name for template in emailTemplates | orderBy track by template.name">
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="subject-row mt-20">
								<insert-variable class="insert-variable" [variable-list-type]="'JOB_MENU_SUBJECT'" (on-variable-choose)="addSubjectVariable($event, 'subject-send-mail-automation')"></insert-variable>
									<div class="field-info">
										<h4>Subject</h4>
										<div class="flex-row">
											<input id="subject-send-mail-automation" ng-disabled="button_disable" type="text" autocomplete="off" class="form-control" required
												   placeholder="Write an awesome subject line. Why not?" maxlength="255"
												   ng-model="email.subject">
										</div>
									</div>
                            </div>

                            <div class="field-info">
															<h4>Message</h4>
                            	<sn-quill-editor-web
                                [init-value]="email.text"
                                [toolbar-settings]="'variables attachments color size font'"
                                [files-obj]="email.attachmentsData"
                                [vars-list]="'JOB_MENU'"
                                [editor-i-d]="'wf_plain_email_or_template'"
                                (on-text-change)="email.text = $event">
                        			</sn-quill-editor-web>

                            <hr class="mt-30 mb-30">

                        </div>
                `,
			replace: true,
			link(scope) {
				const emptyAttachmentsData = {
					attachments: [],
					filesSize: 0
				};

				function clearAttachments() {
					if (scope.email) {
						scope.email.attachmentsData = angular.copy(emptyAttachmentsData);
					}
				}

				const isUserEmail = email =>
					!email.hasOwnProperty('emailTemplateType') &&
					!email.hasOwnProperty('defaultEmailTemplate');

				function setEmailTemplate(data) {
					scope.email = angular.copy(data);
					if (data && data.storedAttachments && data.storedAttachments.length) {
						scope.email.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(
								data.storedAttachments
							)
						};
						scope.$evalAsync();
					} else {
						clearAttachments();
					}
				}

				scope.addSubjectVariable = function($event, id) {
					const el = document.getElementById(id);
					scope.email.subject = emailService.addSubjectVariable(el, $event);
				};

				scope.$watchCollection(
					'email.attachmentsData',
					(newValue, oldValue) => {
						if (
							newValue &&
							newValue !== oldValue &&
							newValue.attachments.length &&
							newValue.attachments.length !== 0 &&
							scope.isUserEmail
						) {
							addUploadedAttachments(newValue);
						}
					}
				);

				function addUploadedAttachments(attachmentsData) {
					const { attachments } = attachmentsData;

					scope.uploadedAttachments = [];
					angular.forEach(attachments, attachment => {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							const copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				const showErrorMessage = () => {
					messageService.showToaster('e_0', 'general');
				};

				scope.addNewTemplate = () => {
					scope.email = {
						name: '',
						text: '',
						attachmentsData: angular.copy(emptyAttachmentsData)
					};
					scope.emailInfo.isEmailShown = true;
				};

				scope.getEmailTemplate = email => {
					if (email === null || email === undefined) {
						scope.email = {
							text: '',
							attachmentsData: angular.copy(emptyAttachmentsData)
						};
					} else if (email && typeof email === 'object') {
						const isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);

						if (isUserEmailChosen) {
							scope.email = email;
							if (
								(email.storedAttachments && email.storedAttachments.length) ||
								(scope.uploadedAttachments && scope.uploadedAttachments.length)
							) {
								const storedAttachments = angular.copy(email.storedAttachments);
								const allAttachments =
									storedAttachments !== null
										? angular.copy(email.storedAttachments)
										: [];

								if (
									scope.uploadedAttachments &&
									scope.uploadedAttachments.length
								) {
									angular.forEach(scope.uploadedAttachments, attachment => {
										allAttachments.push(attachment);
									});
								}
								scope.email.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService
								.getTemplates('full_template', email.id)
								.subscribe(
									data => setEmailTemplate(data),
									error => showErrorMessage()
								);
						}
					} else {
						console.error('no chosen email');
					}
				};

				scope.disableDragDrop = function() {
					return true;
				};

				scope.uploadedAttachments = [];
				const email = scope.email;
				const isUserEmailChosen = isUserEmail(email);
				if (isUserEmailChosen) {
					scope.isUserEmail = true;
				} else if (email && typeof email === 'object' && email.id) {
					scope.getEmailTemplate(scope.email);
				} else {
					console.error('no scope.email.id');
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addMail.js